const sessionKey = "accesed";
const sessionValue = true;

window.addEventListener(
  "load",
  () => {
    //初回アクセス時の処理
    if (!sessionStorage.getItem(sessionKey)) {
      window.setTimeout(() => {
        document.getElementById("cta-line-popup").classList.add("is-active");
      }, 60000);
      document.querySelector(".cta-line-popup__close").addEventListener("click", () => {
        document.getElementById("cta-line-popup").classList.remove("is-active");
        sessionStorage.setItem(sessionKey, sessionValue);
      });
      document.querySelector(".cta-line-popup__overlay").addEventListener("click", () => {
        document.getElementById("cta-line-popup").classList.remove("is-active");
        sessionStorage.setItem(sessionKey, sessionValue);
      });
    }
  },
  false
);
